import { Auditable, QueryParams, SortParams } from "..";
import { FollowUp } from "./FollowUp";

export interface CaseFollowUp extends Auditable {
    caseId: number;
    followUpId: number;
    signedByUserId?: number;
    signedOn?: string;
    notes: string;

    followUp?: FollowUp;
}

export const DefaultCaseFollowUpQueryParams: QueryParams = {
    caseId: "",
};

export const DefaultCaseFollowUpSortParams: SortParams = {
    orderBy: "",
    orderDesc: "false",
};
